const AWARDS_CLAIM_START_DATE_SETTING = "Awards Claim Start Date";

const getAwardsClaimStartDateSettingValue = (settings = {}) =>
  settings[AWARDS_CLAIM_START_DATE_SETTING]?.settingDate ||
  settings[AWARDS_CLAIM_START_DATE_SETTING]?.value ||
  null;

const dateOnlyPattern = /^(\d{4})-(\d{2})-(\d{2})(?:T00:00(?::00(?:\.000)?)?(?:Z)?)?$/;

export const getAwardsReleaseDate = (settings = {}) => {
  const rawClaimStartDate = getAwardsClaimStartDateSettingValue(settings);
  if (!rawClaimStartDate) return null;

  if (typeof rawClaimStartDate === "string") {
    const dateOnlyMatch = rawClaimStartDate.match(dateOnlyPattern);
    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  }

  const releaseDate = new Date(rawClaimStartDate);
  return Number.isNaN(releaseDate.getTime()) ? null : releaseDate;
};

export const canStudentsViewAwards = (settings = {}, now = new Date()) => {
  const releaseDate = getAwardsReleaseDate(settings);
  if (!releaseDate) return false;

  return now >= releaseDate;
};
